import Modal from 'react-modal';
import React from 'react';
function DefaultModal(props: any) {
    return (
        <Modal
            className="precheck-submitted-modal rounded bg-white border d-flex flex-column text-center"
            isOpen={props.open}
            onRequestClose={() => props.handleClose()}>
            <div className="rounded-top w-100 modal-header"></div>
            <span className="form-title">{props.title}</span>
            <div className="form-subtitle mx-2">{props.subtitle}</div>
            <div className="d-flex justify-content-center w-100">
                <button
                    className="btn bg-dark text-white my-4 mx-2 px-4"
                    onClick={() => props.buttonOneAction()}>
                    {props.buttonOneText}
                </button>
                {props.twoButtons == true && (
                    <button
                        className="btn bg-dark text-white my-4 mx-2 px-4"
                        onClick={() => props.buttonTwoAction()}>
                        {props.buttonTwoText}
                    </button>
                )}
            </div>
        </Modal>
    );
}

export default DefaultModal;
